import React from "react";
import FAQ from "../components/FAQ";
import GetStarted from "../components/GetStarted";
import Image from "../components/Image";
import Link from "../components/Link";
import SEO from "../components/SEO";
import Layout from "../components/_refactored/Layout";
import faqData from "../content/vendor-payments";
import "../styles/global-payments.scss";
import { steps, vendorSeoKeywords } from "../constants/vendor-payments";
import HeroSection from "../partials/vector-payments/HeroSection";
import withLazy from "../hocs/WithLazy";
import { VENDOR_PAYMENTS } from "../constants/Url";
import { defaultSupportLink } from "../components/BAV-FAQ/constants";

// Dynamically imported components with withLazy
const PaymentStepsSection = withLazy(() =>
  import("../components/PaymentStepsSection"),
);
const InvoiceWorkflowManagement = withLazy(() =>
  import("../partials/vector-payments/InvoiceWorkflowManagement"),
);
const PricingSection = withLazy(() =>
  import("../partials/vector-payments/PricingSection"),
);

const VendorPaymentsPage = (props) => {
  return (
    <Layout lightHeader {...props}>
      <SEO
        title="Vendor Payments | Upload, Approve, Pay Invoices | Cashfree Payments"
        description="Vendor Payments: Manage all your account payables effortlessly on a single platform. Track invoices, sync with Tally, reconcile easily. Vendor bills, Tax payments, BBPS"
        url="https://www.cashfree.com/vendor-payments/"
        keywords={vendorSeoKeywords}
      />

      {/* hero section */}

      <HeroSection />

      {/* vendor payments steps */}

      <PaymentStepsSection
        backgroundColor="bg-cf-light-grey"
        title="Make Vendor Payments in less than 2 minutes"
        steps={steps}
        BookaDemoContainer
        stepsClass="!mb-[100px]"
      />

      {/* Workflow Management */}

      <InvoiceWorkflowManagement />

      <section className="container">
        <div className="bg-purple-small">
          <p className="md:text-[24px] text-[20px] font-semibold">
            Use no code or simple to integrate API
          </p>
          <Link
            className="button button-green w-full md:w-[224px] md:w-auto"
            to="https://docs.cashfree.com/docs/invoices-payouts#pay-invoices"
            rel="noreferrer"
            target="_blank">
            View Documentation <span className="chevron" />
          </Link>
        </div>
      </section>

      {/* table white bg */}
      <section className="py-[50px] md:py-[100px] vendor-table">
        <div className="container block md:flex justify-between items-start">
          <div className="w-full md:max-w-[439px]">
            <h3 className="text-[24px] md:text-[28px] font-semibold text-cf-hero max-w-[495px] mb-[20px] leading-[34px] md:leading-[39px]">
              Stay ahead of the competition
            </h3>
            <p className="pb-5 text-[16px] text-cf-primary font-semibold">
              Choose the Best. Choose Us.{" "}
            </p>
          </div>
          <div className="w-full md:w-[771px] mt-[20px] md:mt-0 p-[0px] md:px-[25px] md:pt-[10px] md:pb-[30px] rounded">
            <Image
              src={`${VENDOR_PAYMENTS}/Desktop_table.png`}
              alt="table"
              className="hidden md:block"
              width="721"
              height="499"
            />
            <Image
              src={`${VENDOR_PAYMENTS}/Mobile_table.png`}
              alt="table"
              className="block md:hidden"
              width="682"
              height="1124"
            />
          </div>
        </div>
      </section>

      {/* vendor pricing */}
      <PricingSection />

      {/* faq */}
      <div className="container general-faqs large-faqs">
        <FAQ open="0" supportLinkHref={defaultSupportLink} data={faqData} />
      </div>

      {/* footer */}
      <GetStarted utmSourceAction="source-action=Vendor%20Payments" />
    </Layout>
  );
};

export default VendorPaymentsPage;
